
import { parsePhoneNumber, isValidPhoneNumber, formatNumber } from 'libphonenumber-js';

// Convert any phone number to E.164 format
export const formatPhoneNumber = (phone: string): string => {
  try {
    if (!phone || phone.trim() === '') return '';
    
    // If already in E.164 format, return as is
    if (phone.startsWith('+')) {
      const parsedPhone = parsePhoneNumber(phone);
      if (parsedPhone && parsedPhone.isValid()) {
        return parsedPhone.format('E.164');
      }
    }
    
    // Handle Australian format (if starts with 0, assume it's Australian)
    if (phone.startsWith('0')) {
      const phoneWithCountryCode = '+61' + phone.substring(1);
      const parsedPhone = parsePhoneNumber(phoneWithCountryCode);
      if (parsedPhone && parsedPhone.isValid()) {
        return parsedPhone.format('E.164');
      }
    }
    
    // Try with country code
    try {
      // Default to Australian numbers
      const parsedPhone = parsePhoneNumber(phone, 'AU');
      if (parsedPhone && parsedPhone.isValid()) {
        return parsedPhone.format('E.164');
      }
    } catch (error) {
      // Ignore parsing errors when trying with country code
    }
    
    // Fallback to legacy formatting for backward compatibility
    // This ensures we don't break existing functionality
    let formattedPhone = phone;
    if (formattedPhone.startsWith("0")) {
      formattedPhone = "+61" + formattedPhone.substring(1);
    } else if (!formattedPhone.startsWith("+")) {
      formattedPhone = "+" + formattedPhone;
    }
    return formattedPhone;
  } catch (error) {
    console.warn("Phone formatting error:", error);
    // Fallback to legacy logic
    let formattedPhone = phone;
    if (formattedPhone.startsWith("0")) {
      formattedPhone = "+61" + formattedPhone.substring(1);
    } else if (!formattedPhone.startsWith("+")) {
      formattedPhone = "+" + formattedPhone;
    }
    return formattedPhone;
  }
};

// Validate phone number (focused on Australian numbers)
export const validatePhoneNumber = (phone: string): boolean => {
  try {
    if (!phone) return false;
    
    // Try to validate with library
    if (isValidPhoneNumber(phone, 'AU')) {
      return true;
    }
    
    // If it starts with 0, try with country code
    if (phone.startsWith('0')) {
      const phoneWithCountryCode = '+61' + phone.substring(1);
      if (isValidPhoneNumber(phoneWithCountryCode, 'AU')) {
        return true;
      }
    }
    
    // Fallback to regex for backward compatibility
    const phoneRegex = /^(\+?61|0)[4-5]\d{8}$/;
    return phoneRegex.test(phone);
  } catch (error) {
    console.warn("Phone validation error:", error);
    // Fallback to regex for backward compatibility
    const phoneRegex = /^(\+?61|0)[4-5]\d{8}$/;
    return phoneRegex.test(phone);
  }
};

// Display phone in a readable format
export const formatPhoneForDisplay = (phone: string): string => {
  try {
    if (!phone) return '';
    
    const parsedPhone = parsePhoneNumber(phone);
    if (parsedPhone && parsedPhone.isValid()) {
      return parsedPhone.formatNational();
    }
    
    return phone; // Return as-is if parsing fails
  } catch (error) {
    return phone; // Return as-is if parsing fails
  }
};
